"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _i18n = _interopRequireDefault(require("../../util/i18n.js"));

var _MorningstarRow = _interopRequireDefault(require("./MorningstarRow"));

require("./MorningstarTable.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var MorningstarTable =
/*#__PURE__*/
function (_Component) {
  _inherits(MorningstarTable, _Component);

  function MorningstarTable(props) {
    var _this;

    _classCallCheck(this, MorningstarTable);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MorningstarTable).call(this, props));
    _this.state = {
      i18n: _this.props.translationDictionary ? _this.props.translationDictionary : _i18n.default
    };
    return _this;
  }

  _createClass(MorningstarTable, [{
    key: "renderRows",
    // create the rows
    value: function renderRows() {
      var i18n = this.state.i18n;
      var data = this.props.data; // Filter out Common Stock

      return data.filter(function (x) {
        return x.type === 'WTETF';
      }).map(function (fund, index) {
        return _react.default.createElement(_MorningstarRow.default, {
          key: index,
          fund: fund,
          index: index,
          i18n: i18n
        });
      });
    } // create the header

  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var i18n = this.state.i18n;
      var data = this.props.data;
      var asOfDate = new Date(data[0].morningStarScorecard[0].date).toLocaleDateString();
      return _react.default.createElement("thead", null, _react.default.createElement("tr", null, _react.default.createElement("th", {
        colSpan: "3",
        scope: "colgroup",
        className: "textLeft"
      }, i18n.t('as of'), " ", asOfDate), _react.default.createElement("th", {
        colSpan: "2",
        scope: "colgroup",
        className: "borderleft borderbottom textCenter"
      }, i18n.t('morningstar'))), _react.default.createElement("tr", null, _react.default.createElement("th", {
        scope: "col",
        className: "textLeft sticky ticker"
      }, i18n.t('ticker')), _react.default.createElement("th", {
        scope: "col",
        className: "textLeft category"
      }, i18n.t('category')), _react.default.createElement("th", {
        scope: "col",
        className: "textLeft category"
      }, i18n.t('time-period')), _react.default.createElement("th", {
        scope: "col",
        className: "borderleft textCenter category"
      }, i18n.t('overall-morningstar-rating')), _react.default.createElement("th", {
        scope: "col",
        className: "textCenter category"
      }, i18n.t('overall-number-funds'))));
    }
  }, {
    key: "render",
    value: function render() {
      var i18n = this.state.i18n;
      var showTitle = this.props.showTitle;
      return _react.default.createElement("div", {
        className: "morningstar-table-container"
      }, showTitle ? _react.default.createElement("div", {
        className: "heading"
      }, i18n.t('Standardized Performance')) : null, _react.default.createElement("div", {
        className: "table-responsive"
      }, _react.default.createElement("table", {
        className: "table"
      }, this.renderHeader(), _react.default.createElement("tbody", null, this.renderRows()))), _react.default.createElement("div", null, _react.default.createElement("br", null)));
    }
  }]);

  return MorningstarTable;
}(_react.Component);

_defineProperty(MorningstarTable, "defaultProps", {
  data: null,
  translationDictionary: null,
  showTitle: false
});

MorningstarTable.propTypes = {
  /**
   * Fund data to be used for Morningstar fund data - should be an array. Should be Mongo _cls: Entity
   */
  data: _propTypes.default.array.isRequired,

  /**
   * Translation dictionary (i18) - needed for tables, but can default to included version
   */
  translationDictionary: _propTypes.default.object
};
var _default = MorningstarTable;
exports.default = _default;